var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BCD121EA-BAD3-4ED3-8805-F2C54148A239") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-490.000000, -836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-55",
    transform: "translate(490.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14,7.45454545 L14,5 L10.75,8.27272727 L14,11.5454545 L14,9.09090909 C16.689375,9.09090909 18.875,11.2918182 18.875,14 C18.875,14.8263636 18.671875,15.6118182 18.30625,16.2909091 L19.4925,17.4854545 C20.12625,16.4790909 20.5,15.2845455 20.5,14 C20.5,10.3836364 17.59125,7.45454545 14,7.45454545 Z M14,18.9090909 C11.310625,18.9090909 9.125,16.7081818 9.125,14 C9.125,13.1736364 9.328125,12.3881818 9.69375,11.7090909 L8.5075,10.5145455 C7.87375,11.5209091 7.5,12.7154545 7.5,14 C7.5,17.6163636 10.40875,20.5454545 14,20.5454545 L14,23 L17.25,19.7272727 L14,16.4545455 L14,18.9090909 Z",
    id: "Shape",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.4b52ba87b083c5e6e20973d24266c986.svg";
export { ForwardRef as ReactComponent };